<template>
  <div class="indexActivity">
    <div>
      <div class="activityContent">
        <img :src="activityDetial.navImg" />
        <div>
          <h2>{{ this.activityDetial.name }}</h2>
          <template v-if="this.activityDetial.typeName == '临时展'">
            <p>时间：{{ this.activityDetial.seTime }}</p>
          </template>
          <template v-else>
            <p> 类型： <span class="tag-wrap">常规展</span> </p>
          </template>
          <p> 地点：{{ this.activityDetial.areaAddress }} {{ this.activityDetial.name }} <span class="underline"
              @click="showHallImg()">查看展厅图片</span>
          </p>

          <div>
            <p>简介：</p>
            <el-popover placement="top-start" width="600" trigger="hover" :content="this.activityDetial.remark">
              <p class="remark-wrap" slot="reference">
                {{ this.activityDetial.remark }}
              </p>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="otherInfo">
        <div class="order">
          <div class="orderFormInfo">
            <div class="dateTimeList" v-if="dateTimeList.length > 0">
              <div class="dateList">
                <div class="dateContainer" id="dateContainer">
                  <template v-for="(item, index) in dateTimeList">
                    <p v-if="item.residueMake > 0" :key="'date' + index" @click="choseDate(index)" class="date-item"
                      :class="{ chose: dateChose == index }">
                      {{ item.makeDate }}
                    </p>
                    <el-popover v-else :key="'date' + index" placement="top-start" title="提示" width="120" trigger="hover">
                      <p class="date-item time-ban" slot="reference">
                        <template v-if="item.message == '此日期被临时关闭'">非开放日</template>
                        <template v-else-if="item.message == '已到达每天可预约上限'">已约满</template>
                        <template v-else-if="item.message == '已到达展览每月预约上限'">已约满</template>
                        <template v-else-if="item.message == '无可用时间段'">已约满</template>
                        <template v-else>已约满</template>
                      </p>
                    </el-popover>
                  </template>
                </div>
              </div>
              <div class="timeList" v-if="timeList.length > 0">
                <template v-for="(item, index) in timeList">
                  <el-popover v-if="item.status == 3" :key="index" placement="top-start" title="提示" width="120"
                    trigger="hover" content="由于当前时段已经被其他团体预约了，一个时段只接收一个团体预约">
                    <div class="time-item time-ban" slot="reference">
                      已约满
                    </div>
                  </el-popover>
                  <el-popover v-else-if="item.status == 2" :key="index" placement="top-start" title="提示" width="120"
                    trigger="hover" content="当前时段已经关闭，不可预约">
                    <div class="time-item time-ban" slot="reference">
                      已约满
                    </div>
                  </el-popover>
                  <div v-else class="time-item" :key="index" @click="choseTime(index)" slot="reference"
                    :class="{ 'time-chose': timeChose == index }">
                    {{ formatTime(item.slice) }}
                  </div>
                </template>
              </div>
              <div class="timeList empty" v-if="dateTimeList.length == 0">
                <span>今日闭展</span>
              </div>
            </div>
            <div class="dateTimeList" v-if="dateTimeList.length == 0">
              <div class="notime">此活动未开展，请等待~</div>
            </div>
            <div class="peopleList" v-if="party == 2 || true">
              <div class="title">
                <div v-if="followFieldDTOList!=''">
                  <p>添加人员(最多{{ this.max }}人)</p>
                  <p @click="changeModal(1)" >
                    <i class="el-icon-plus"></i>
                  </p>
                </div>
                   <div v-if="followFieldDTOList==0" class="top-int">
                      <div>随行人数量：</div>
                    </div>
              </div>
              <div class="content">
                <template v-if="peopleList.length > 0">
                  <div class="people-item-wrap" v-for="(item, index) in peopleList" :key="index">
                    <div class="info-content-wrap">
                      <div class="user-name-wrap">
                        <div class="user-name" v-show="isShow('fullName')">{{ item.fullName }}</div>
                        <div class="unit-wrap" v-show="isShow('unit')">{{ item.unit }}</div>
                      </div>
                      <div class="username-wrap" v-show="isShow('username')">学号：<span class="word-wrap">{{ item.username
                      }}</span></div>
                      <div class="cardNum-wrap" v-show="isShow('cardNum')">证件号：<span class="word-wrap">{{ item.cardNum
                      }}</span></div>
                    </div>
                    <div class="delete-btn-wrap" @click="deletePeople(index)"><i class="el-icon-delete"></i></div>
                  </div>
                </template>
                <div class="items" v-if="peopleList.length == 0 ">
                  <div class="nodata" v-if="followFieldDTOList!=0">
                    <input type="file" @change="loadExcel" id="excelFile" />
                    <span class="operate">
                      暂未添加人员,
                      <span class="upload" @click="upload">试试导入人员</span>
                      <span class="downLoad">
                        <a :href="excelPath" target="_blank" download="导入人员模板.xls">下载模板</a>
                      </span>
                    </span>
                  </div>
                  <div class="nodata nodata_" v-if="followFieldDTOList==0">
                    <div>   随行人数不得低于15人&nbsp;&nbsp;<i class="el-icon-warning"></i></div>
                    <div>
                      <el-input v-model="followNum" placeholder="请输入随行人数量"></el-input>
                    </div>
                    <!-- <div v-if="followFieldDTOList==0" class="top-int">
                      <div>随行人数量：</div> <input type="text" v-model="followNum"  placeholder="请输入随行人员人数" />
                    </div> -->
                    <!-- <el-empty description="随行人数不得低于15人"></el-empty>
                    随行人员人数： <input type="text" v-model="followNum"  placeholder="请输入随行人员人数" /> -->
                  </div>
                </div>
              </div>
              <!-- 新需求：屏蔽显示是否预约讲解员，团体预约默认分配讲解员，在公告里面加上这个说明 -->
              <div class="orderGuide" v-if="party == 2 && false">
                <div>是否预约讲解员</div>
                <el-switch v-model="guide" active-value="1" inactive-value="0">
                </el-switch>
              </div>
            </div>
          </div>
          <div class="commentList1">
            <div class="title">
              <p>精彩评论</p>
              <p></p>
            </div>
            <div v-if="this.comment.list.length == 0" class="content">
              <div class="nodata">
                <span>此活动暂无评论~</span>
              </div>
            </div>
            <div class="content" v-else>
              <div class="comment" v-for="(item, index) in this.comment.list" :key="index">
                <div class="info">
                  <el-avatar :size="avatar.size" :src="item.headImgUrl ? item.headImgUrl : avatar.circleUrl"
                    class="avator"></el-avatar>
                  <p class="name">{{ item.fullName }}</p>
                  <p>评分: {{ item.score }}分</p>
                  <!-- <el-rate v-model="item.score" disabled show-score text-color="#ff9900" score-template></el-rate> -->
                </div>
                <div class="descri">
                  <p>{{ item.content }}</p>
                </div>
                <div class="comment-time">
                  <p>{{ item.createdDate }}</p>
                </div>
                <div v-show="item.hfNum > 0 && !item.isShow" class="comment-list-wrap"
                  @click="getCommont(item.id, index)">
                  展开更多回复
                  <i class="el-icon-caret-bottom"></i>
                </div>
                <template v-if="item.hfNum > 0 && item.isShow">
                  <div class="commont-children-item" v-for="(el, index) of item.list" :key="index">
                    <div class="info">
                      <el-avatar :size="avatar.size" :src="el.headImgUrl ? el.headImgUrl : avatar.circleUrl"
                        class="avator"></el-avatar>
                      <p class="name">{{ el.fullName }}</p>
                      <p>评分: {{ el.score }}分</p>
                    </div>
                    <div class="descri">
                      <p>{{ el.content }}</p>
                    </div>
                    <div class="comment-time">
                      <p>{{ el.createdDate }}</p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="commentList">
      <div class="title">
        <p>展览详情</p>
        <p></p>
      </div>
      <div class="contentVu content" id="contentVu" v-html="this.activityDetial.content == 'null'
        ? ''
        : this.activityDetial.content
        "></div>
      <div class="submit" v-if="dateTimeList.length > 0">
        <button class="canncel" @click="goback">返回</button>
        <!-- <button
          v-if="timeList.length>0 ||(timeList.length==0&&party==1)"
          class="order"
          @click="order"
        >预约活动</button>-->
        <button class="order" @click="order" v-if="isSumbit">提交预约</button>
        <el-button class="order gray-info" v-else>提交预约</el-button>
        <!-- <button v-if="timeList.length==0&&party==2" class="clsoe" @click="close">预约活动</button> -->
      </div>
    </div>
    <el-dialog :title="addModal.type == 1 ? '添加人员' : '上传申请书'" :visible.sync="addModal.show" :close-on-click-modal="false"
      class="closeModal">
      <el-form v-if="addModal.type == 1" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label-width="120px" :label="'人员列表1(' + peopleList.length + '/' + max + ')'"
          v-if="peopleList.length > 0">
          <el-tag width="80px" v-for="(people, index) in peopleList" :key="'people' + index" @close="deletePeople(index)"
            closable>{{
              people.fullName ||
              people.cardNum ||
              people.unit ||
              people.username
            }}</el-tag>
        </el-form-item>
        <el-form-item label-width="120px" label="人员名称" prop="fullName" v-show="isShow('fullName')">
          <el-input v-model="ruleForm.fullName" placeholder="请输入人员名称"></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="证件类型" prop="cardType" v-show="isShow('cardType')">
          <el-radio-group v-model="ruleForm.cardType">
            <el-radio label="0">居民身份证</el-radio>
            <el-radio label="1">护照</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label-width="120px" label="证件号码" prop="cardNum" v-show="isShow('cardNum')">
          <el-input v-model="ruleForm.cardNum" placeholder="请输入证件号码"></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="单位" prop="unit" v-show="isShow('unit')">
          <el-input v-model="ruleForm.unit" placeholder="请输入单位名称"></el-input>
        </el-form-item>
        <el-form-item label-width="120px" label="学号" prop="username" v-show="isShow('username')">
          <el-input v-model="ruleForm.username" placeholder="请输入学号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pushPeople()">添加</el-button>
          <el-button @click="changeModal(1)">关闭</el-button>
        </el-form-item>
      </el-form>
      <el-form v-if="addModal.type == 2" label-width="100px" class="demo-ruleForm">
        <el-form-item label="申请书">
          <el-button size="small" class="tj_btn" type="primary" @click="uploadTwo">点击下载</el-button>
          <el-upload class="upload-demo" action :http-request="uploadImg2" :file-list="files" :before-upload="checkFile"
          :before-remove="close1" :limit="1" accept="application/pdf,image/jpeg,image/png,.docx,.xml">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip" >
           请上传pdf或者图片，且不超过500kb
          </div>  
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="order()">提交预约</el-button>
          <el-button @click="changeModal(1)">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="activityDetial.areaName + '的图片'" :visible.sync="hallImgShow" class="closeModal">
      <img :src="this.activityDetial.areaImgPath" style="max-width: 100%" />
    </el-dialog>
    <el-dialog title="信息确认" :visible.sync="infoShow" class="closeModal">
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px">
        <el-form-item  label=" 申请书" v-if="detailData.isCheck==1&&detailData.annexPath!=''" required>
          <el-button size="small" class="tj_btn" type="primary" @click="uploadTwo">点击下载</el-button>
          <el-upload class="upload-demo" action :http-request="uploadImg2" :file-list="files" :before-upload="checkFile"
          :before-remove="close1" :limit="1" accept="application/pdf,image/jpeg,image/png,.docx,.xml">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
           请上传pdf或者图片，且不超过500kb
          </div>  
          </el-upload>
        </el-form-item>
        <el-form-item label="所属团队" required>
          <el-input v-model="formInline.personFrom" placeholder="请输入所属团队" aria-required></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input v-model="formInline.phone" placeholder="输入您的联系电话"></el-input>
        </el-form-item>
        <div class="tip" style="text-align: center;">注：请如实填写团队人数与身份信息，若与实际不符，则预约无效</div>
        <el-form-item style="display: flex;justify-content:center;">
          <el-button type="primary" @click="onSubmit" >确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getActivityComment,
  findExhibitMakeDetails,
  getFollowData,
  orderActivity,
  uploadFile,
  getCommont,
  getTimeSlice
} from "@/libs/api";
import Moment from "moment";
import { Base64 } from "@/utils/encoding";
import { readExcel } from "@/utils/xlsx";
import XLSX from "xlsx";
export default {
  data() {
    return {
      isSumbit: true,
      excelPath: require("../../assets/data/导入人员模板.xls"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      value: 1,
      avatar: {
        circleUrl:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        size: "small"
      },
      formInline: {
        personFrom: "",
        phone: ""
      },
      str: "由于当前时段已经被其他团体预约了，一个时段只接收一个团体预约",
      infoShow: false,
      followNum:'',
      max: 19,
      followFieldDTOList: "",
      fileUrl: "",
      party: sessionStorage.getItem("party"),
      hallImgShow: false,
      activityDetial: {},
      dateTimeList: [],
      dateChose: 0,
      timeChose: -1,
      comment: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        list: []
      },
      guideId: "",
      peopleList: [],
      hallId: "",
      addModal: {
        show: false,
        type: 1
      },
      ruleForm: {
        fullName: "",
        cardType: "0",
        cardNum: "",
        unit: "",
        username: ""
      },
      fields: [],
      files: [],
      passFile: ["png", "pneg", "jpg", "jpeg", "pdf", "word",'excel','docx','xml'],
      maxFile: 10,
      guide: "1",  // 屏蔽显示是否预约讲解员，团体预约默认分配讲解员，在公告里面加上这个说明
      xlsx: "",
      detailData:{}
    };
  },
  methods: {
    //下载申请书
    uploadTwo(){
        let url = this.detailData.annexPath 
        const a = document.createElement('a')
        a.href = url
        a.download = this.detailData.annexName // 下载后文件名
        console.log(a.download)
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click() // 点击下载
        document.body.removeChild(a) // 下载完成移除元素
    },
    // 获取时间片段
    getTimeSliceFunction(data, id) {

      if (this.party == 1) {
        return;
      }
      this.timeChose = -1;
      getTimeSlice(data, id)
        .then(res => {
          if (res.code == 200) {
            this.timeList = res.data.timeSlice;
            let array = res.data.timeSlice;
            for (let i = 0; i < array.length; i++) {
              if (array[i].status == 1) {
                this.timeChose = i;
                break;
              }
            }
            if (this.timeChose == -1) {
              this.isSumbit = false;
              this.$alert("当前时段已闭馆, 不可预约", "提示", {
                confirmButtonText: "确定",
                callback: action => { }
              });
            }
            this.$forceUpdate();
          } else {
            console.log("接口请求错误");
          }
        })
        .catch(err => {
          console.log("网络错误：", err);
        });
    },

    getCommont(id, index) {
      getCommont(id).then(res => {
        if (res.status) {
          let obj = {
            ...this.comment.list[index],
            isShow: true,
            list: res.data.pageList
          };
          this.comment.list.splice(index, 1, obj);
          this.$forceUpdate();
        }
      });
    },

    //格式化时间段
    formatTime(str) {
      return str.replace(/_/g, "-");
    },

    close: function () {
      this.$alert("当前时段已闭馆, 不可预约", "提示", {
        confirmButtonText: "确定",
        callback: action => { }
      });
    },

    upload: function () {
      document.getElementById("excelFile").click();
    },

    isEmptyObject(object) {
      let result = Object.values(object).find(el => el)
      return result ? true : false
    },
    loadExcel: function (e) {
      var peopleList = this.peopleList;
      this.readExcel(document.getElementById("excelFile").files[0]).then(res => {
        document.getElementById("excelFile").value = "";
        res.forEach(element => {
          if (!this.isEmptyObject(element)) return
          if (peopleList.length >= this.max) {
            return this.$alert(
              "随行人员不得超过" + this.max + "人",
              "温馨提示"
            );
          }
          peopleList.push(element);
        });
        this.peopleList = peopleList;
      })
        .catch(res => {
          document.getElementById("excelFile").value = "";
        });
    },

    isShow(str) {
      try {
        let result = this.followFieldDTOList.filter(item => {
          return item.field == str;
        });
        if (result && result.length > 0) {
          return true;
        } else {
          return false;
        }
      } catch (err) { }
    },
    readExcel: function (file) {
      //表格导入
      var that = this;
      return new Promise((resolve, reject) => {
        if (file == null) {
          //如果没有文件名
          reject(-1);
        } else if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
          this.$alert("上传格式不正确，请上传xls或者xlsx格式", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              reject(-1);
            }
          });
        } else {
          const fileReader = new FileReader();
          fileReader.onload = ev => {
            // try {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {
              type: "binary"
            });
            const wsname = workbook.SheetNames[0]; //取第一张表
            const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
            that.outputs = []; //清空接收数据
            for (var i = 0; i < ws.length; i++) {
              var sheetData = {
                fullName: ws[i].人员名称 || "",
                cardType: ws[i].证件类型
                  ? ws[i].证件类型.trim() === "身份证"
                    ? "0"
                    : "1"
                  : "",
                cardNum: ws[i].证件号 || "",
                unit: ws[i].单位 || "",
                username: ws[i].学号 || ""
              };
              that.outputs.push(sheetData);
            }
            resolve(that.outputs);
            // } catch (e) {
            //   reject(-1)
            //   return;
            // }
          };
          fileReader.readAsBinaryString(file, "UTF-8");
        }
      });
    },

    isEmpty(str, item, i) {
      if (item.hasOwnProperty(str)) {
        if (item[str].trim == "") {
          this.$alert(`第${i + 1}行数据中，${str}为空~`);
        }
      }
      return true;
    },

    showHallImg: function () {
      this.hallImgShow = true;
    },
    goback: function () {
      this.$router.go(-1);
    },

    orderGuide: function (data) {
      this.guide = data.FULLNAME;
      this.guideId = data.id;
      this.changeModal();
    },
    changeModal: function (type) {
      this.addModal.show = !this.addModal.show;
      this.addModal.type = type;
      this.files.length = [];
      this.ruleForm = {
        fullName: "",
        cardType: "0",
        cardNum: "",
        unit: "",
        username: ""
      };
    },
    deletePeople: function (index) {
      this.$confirm('你正在删除随行人员，请问是否继续！', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.peopleList.splice(index, index + 1);
      })
    },
    pushPeople: function () {
      if (this.peopleList.length >= this.max) {
        this.$alert("参加活动人员最多" + this.max + "人", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.changeModal();
          }
        });
      } else {
        if (this.isShow("fullName") && this.ruleForm.fullName == "") {
          this.$alert("姓名不能为空！");
          return;
        }
        if (this.isShow("cardNum") && this.ruleForm.cardNum == "") {
          this.$alert("证件号码不能为空！");
          return;
        }
        if (this.isShow("cardNum") && this.ruleForm.cardNum != "") {
          //验证身份证
          if (this.ruleForm.cardType == "0") {
            let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if (!reg.test(this.ruleForm.cardNum)) {
              this.$alert("请输入正确的证件号码~");
              return;
            }
          } else {
            //验证护照
            let reg = /^((1[45]\d{7})|(G\d{8})|(P\d{7})|(S\d{7,8}))?$/;
            if (!reg.test(this.ruleForm.cardNum)) {
              this.$alert("请输入正确的证件号码~");
              return;
            }
          }
        }
        if (this.isShow("unit") && this.ruleForm.unit == "") {
          this.$alert("单位名称不能为空！");
          return;
        }
        if (this.isShow("username") && this.ruleForm.username == "") {
          this.$alert("学号不能为空！");
          return;
        }
        this.peopleList.push(this.ruleForm);
        this.ruleForm = {
          fullName: "",
          cardType: "0",
          cardNum: "",
          unit: "",
          username: ""
        };
      }
    },
    choseDate: function (item) {
      console.log(item);
      this.dateChose = item;
      this.timeChose = -1;
      this.getTimeSliceFunction(
        this.dateTimeList[item].makeDate,
        this.$route.query.id
      );
    },
    choseTime: function (item) {
      this.timeChose = item;
    },
    scollChange: function (direction) {
      let timeContainer = document.getElementById("dateContainer");
      let scroll = "";
      let width = 0;
      if (direction === "left") {
        scroll = setInterval(function () {
          if (width >= 741) {
            clearInterval(scroll);
          }
          width += 6.175;
          timeContainer.scrollLeft = timeContainer.scrollLeft - 6.175;
        }, 4);
      } else {
        scroll = setInterval(function () {
          if (width >= 741) {
            clearInterval(scroll);
          }
          width += 6.175;
          timeContainer.scrollLeft = timeContainer.scrollLeft + 6.175;
        }, 4);
      }
    },

    //获取展览详情
    getActivityDetial: function () {
      var base = new Base64();
      findExhibitMakeDetails(this.getFormatDate(), this.$route.query.id).then(
        data => {
          // console.log(data,'详情')
          if (data.status) {
            // 这里是获取返回所有的详情内容
            this.detailData = data.data
            this.activityDetial = data.content;
            this.activityDetial.content = this.activityDetial.content
              .replace("<img", '<img style="max-width: 100%"')
              .replace('<p style="', '<p style="color: white !important;');
            this.dateTimeList = data.content.residueTimeSliceList;
            let array = data.content.residueTimeSliceList;
            for (let i = 0; i < array.length; i++) {
              if (array[i].residueMake > 0) {
                this.dateChose = i;

                break;
              }
            }
            if (this.dateChose != -1) {
              // console.log(this.dateTimeList[this.dateChose].makeDate);
              this.getTimeSliceFunction(
                this.dateTimeList[this.dateChose].makeDate,
                this.$route.query.id
              );
            } else {
              this.isSumbit = false;
            }
            this.$forceUpdate();
            this.timeList = data.content.timeSlice;
          } else {
            this.$alert("展览活动获取失败。请稍后再试", "提示", {
              confirmButtonText: "确定",
              callback: action => { }
            });
          }
        }
      );
      
    },

    getTime() {
      if (this.activityDetial.typeName == "常规展") {
        return this.getDate(1);
      } else {
        let star = this.activityDetial.seTime.split("~")[0];
        let end = this.activityDetial.seTime.split("~")[1];
        return this.getDate(2, star, end);
      }
    },

    //获取可预约日期
    getDate(flag, star, end) {
      if (flag == 1) {
        star = new Date().getTime();
        end = star * 1000 * 60 * 60 * 24 * 30;
      } else {
        star = new Date(star.replace(/-/g, "/")).getTime();
        end = new Date(end.replace(/-/g, "/")).getTime();
      }
      let array = [];
      while (star <= end) {
        let year = new Date(star).getFullYear();
        let month =
          new Date(star).getMonth() > 8
            ? new Date(star).getMonth() + 1
            : "0" + (new Date(star).getMonth() + 1);
        let day =
          new Date(star).getDate() > 9
            ? new Date(star).getDate()
            : "0" + new Date(star).getDate();
        let flag = true;
        if (new Date().getTime() < star) {
          flag = false;
        }
        array.push({ flag: flag, date: `${year}-${month}-${day}` });
        star = star + 1000 * 60 * 60 * 24;
      }
      return array;
    },

    getFormatDate(date = "") {
      if (date == "") {
        date = new Date();
      } else {
        date = new Date(date.replace(/-/g, "/"));
      }
      let year = date.getFullYear();
      let month =
        date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
      let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
      return `${year}-${month}-${day}`;
    },

    //获取展览评论
    getCommentList: function (currentPage) {  
      this.comment.currentPage =
        currentPage == undefined ? this.comment.currentPage : currentPage;
      getActivityComment(
        this.$route.query.id,
        this.comment.currentPage,
        this.comment.pageSize
      ).then(data => {
        if (data.status) {
          // console.log('评论列表：', data);
          this.comment.list = data.content.pageList;
          this.comment.totalCount = data.content.totalCount;
        } else {
          this.$alert("评论获取失败。请稍后再试", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
      });
    },
    order: function () {
      if (this.userInfo.flag == 40 || this.userInfo.flag == 30) {
        if ((this.followNum==='' || this.followNum<15)&&(this.followFieldDTOList.length==0)&&this.userInfo.flag == 40 ) {
          return this.$alert("团队预约最少15人", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
        if ((this.peopleList.length < 15)&&(this.followFieldDTOList.length!=0)&&this.userInfo.flag == 40 ) {
          return this.$alert("团队预约最少15人", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
        if (this.peopleList.length>this.max&&(this.followFieldDTOList.length!=0)&&this.userInfo.flag == 40 ) {
          return this.$alert(`团队预约最多${this.max}人`, "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
        if (this.followNum>this.max&&(this.followFieldDTOList.length==0)&&this.userInfo.flag == 40 ) {
          return this.$alert(`团队预约最多${this.max}人`, "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
        // 新增需求校外团体按照校内团体预约
        if (this.userInfo.flag == 40) return this.infoShow = true;

        if (this.files.length == 0&&this.detailData.isCheck==1&&this.detailData.annexPath!='') {
          if (this.addModal.show && this.addModal.type == 2) {
            return this.$alert("请上传预约申请书", "提示", {
              confirmButtonText: "确定",
              callback: action => { }
            }); 
          } else {
            this.changeModal(2);
          }
        }else{
          this.orderActivity();
        }
      } else {
        console.log(this.formInline.personFrom,this.formInline.phone)
        // 如果是校内培训 或者 校内团队(校内个人/团体)
        if ((this.party == 2 && this.userInfo.flag == 10) || this.userInfo.flag == 20) {
          // if(this.)
          if(this.followFieldDTOList.length!=0){
            if (this.party == 2 && this.userInfo.flag == 10 && this.peopleList.length < 15) {
            return this.$alert("团队预约最少15人", "提示", {
              confirmButtonText: "确定",
              callback: action => { }
            });
            }
          }else{
            if ((this.followNum==='' || this.followNum<15)&&(this.followFieldDTOList.length==0)) {
              return this.$alert("团队预约最少15人", "提示", {
                confirmButtonText: "确定",
                callback: action => { }
              });
            }
            if (this.followNum>this.max&&(this.followFieldDTOList.length==0)) {
              return this.$alert(`团队预约最多${this.max}人`, "提示", {
                confirmButtonText: "确定",
                callback: action => { }
              });
            }
          }
        } 
        this.infoShow = true;
      }
    },
    onSubmit() {
      if (this.formInline.personFrom == '' || this.formInline.phone == '') {
        return this.$alert("所属团队和联系电话是必填项！", "提示", {
          confirmButtonText: "确定",
          callback: action => { }
        });
      }
      if (this.formInline.phone != '') {
        if (!(/^1[3456789]\d{9}$/.test(this.formInline.phone))) {
          return this.$alert("请填写11位的手机号码", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
      }
      this.orderActivity();
    },
    isNotDecimal(value){
      return Number.isInteger(value);
    },
    orderActivity: function () {
      let params = {
        exhId: this.$route.query.id,
        filePath: this.party == 2 ? this.fileUrl : false,
        followMakeDTOList: this.peopleList,
        personFrom: this.guide,
        makeDate: this.dateTimeList[this.dateChose].makeDate,
        annexPath : this.party == 2 ? this.fileUrl : false,
        followNum:this.followNum
      };
      if(this.followNum>0){
        if(!this.isNotDecimal(parseFloat(this.followNum))){
          return this.$alert("预约人数不能为小数", "提示", {
            confirmButtonText: "确定",
            callback: action => { }
          });
        }
      }
      if (this.party == 2) {
        console.log(this.timeList, this.timeChose);
        params.timeSlice = this.timeList[this.timeChose].slice;
        params.personFrom = this.formInline.personFrom;
        params.phone = this.formInline.phone;
      }
      if (this.$route.query.makeLogId != undefined) {
        params.makeLogId = this.$route.query.makeLogId;
      }
      if(this.detailData.isCheck==1&&this.detailData.annexPath!=''&&this.fileUrl==''&&this.infoShow==false){
        this.addModal.show = true;
        this.addModal.type = 2;
      }
      if(this.detailData.isCheck==1&&this.detailData.annexPath!=''&&this.fileUrl==''){
        this.$alert('请上传申请书', "提示", {
            confirmButtonText: "确定",
            callback: action => {
             
            }
          });
        return false
      }
      orderActivity(params).then(data => {
        this.infoShow = false;
        this.addModal.show = false;
        this.addModal.type = 1;
        if (data.status) {
          let str = "预约审核中，1-2个工作日内，请注意查收短信提示！短信确认后才是预约成功！";
          if (!data.data) {
            str = "预约申请提交成功！";
          }
          this.$alert(str, "提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.$router.push({ name: "mine" });
            }
          });
        } else {
          this.$alert(data.message, "提示", {
            confirmButtonText: "确定",
            callback: action => {}
          });
        }
      });
    },
    checkFile(file) {
      let type = file.name
        .toString()
        .substring(
          file.name.toString().lastIndexOf(".") + 1,
          file.name.toString().length
        );
      let size = file.size / 1000 / 1024;
      if (this.passFile.indexOf(type) == -1) {
        this.$alert("申请书只能是word,pdf,图片格式！", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            return false;
          }
        });
        return false;
      } else if (size > this.maxFile) {
        this.$alert("文件大小不能超过10MB!", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            return false;
          }
        });
        return false;
      } else {
        return true;
      }
    },
    uploadImg2: function (fileObj) {
      let formData = new FormData();
      formData.append("files", fileObj.file);
      uploadFile(formData).then(res => {
        if (res.status) {
          this.files[0] = res.content.name;
          this.fileUrl = Global.fileUrl + "/upload/" + res.data.savePath;
          this.$message({
            message: "申请书上传成功！",
            type: "success"
          });
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },
    close1(type, iondex) {
      this.files = [];
    }
  },
  watch: {
    guide(after, before) {
      console.log()
      if(this.followFieldDTOList!=0){
        if (after == "1" && this.party == 2 && this.peopleList.length < 15 ) {
        this.$alert("大于等于15人才能预约讲解员哦~", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.guide = before;
          }
        });
        } else if (after == "1" && this.party == 2) {
          this.$alert(
            "预约讲解员，请在展览开始之前到馆，超时可能无法享受讲解服务哦  (如预约9:00-10:00时段,请在9:00之前到达)",
            "续约须知",
            {
              confirmButtonText: "我已知道"
            }
          );
        }
      }else{
        if(after == "1" && (this.followNum==''||this.followNum<15)){
          this.$alert("大于等于15人才能预约讲解员哦~", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.guide = before;
          }
        });
        }
      }
      
    }
  },
  created() {
    // console.log(this.isNotDecimal())
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? "https://remote.leosys.com.cn:8443/bwg"
        : Global.BASEURL;
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let flag = userInfo.flag;
    if (flag == 10) {
      if (sessionStorage.getItem("party") == 2) {
        flag = 15;
      }
    }
    this.excelPath = `${baseUrl}/static/public/cg/operate/followDownload/${this.$route.query.id}/${flag}`;
    this.getActivityDetial();
    this.formInline.personFrom = JSON.parse(
      sessionStorage.getItem("userInfo")
    ).unit;
    this.formInline.phone = JSON.parse(
      sessionStorage.getItem("userInfo")
    ).phone;
    this.getCommentList(undefined);
    // if (this.party == 2) {
    getFollowData(this.$route.query.id).then(res => {
      if (res.status) {
        this.max = res.data.followMax;
        console.log("随行人员字段：", res.data.followFieldDTOList);
        this.followFieldDTOList = res.data.followFieldDTOList;
      } else {
        this.$alert("随行人员必填字段获取失败~", "提示", {
          confirmButtonText: "确定",
          callback: action => {
            this.guide = before;
          }
        });
      }
      this.followFieldDTOList = res.data.followFieldDTOList;
    });
    // }
  }
};
</script>
<style lang="less" scoped>
.tj_btn{
  position: absolute;
  left: 85px;
  top: 4px;
}
.nodata_{
  //flex-direction:row !important;
  //align-items: center !important;
  
  div{
    width:70%;
    margin:0px auto;
    margin-bottom: 10px;
    background-color: rgba(00, 00, 00, 0) !important;
    div{
      width: 100%;
    }
    input{
      width: 100%  !important;
      display: inline-block !important;
    }
  }
}
.top-int{
  width: 100%;
  display: flex;    
  background: rgba(00, 00, 00, 0) !important;
  align-items:center;
  div{
    height: 100%;
  }
  input{
    height: 100%;
    background: rgba(00, 00, 00, 0);
    border:none ;
    width: 50%;
   }

}

.flex{
  display: flex;
    :first-child{
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;  
      margin-right: 5px;
    }
}
.indexActivity {
  height: 75vh;
  display: flex;
  flex-direction: row;

  >div {
    width: 60%;
    display: flex;
    flex-direction: column;

    .activityContent {
      background-color: #1a1a1ad1;
      padding: 15px;
      display: flex;
      display: flex;

      img {
        height: 120px;
        width: 210px;
      }

      >div {
        margin-left: 25px;
        color: #fffefc;

        h2 {
          margin-bottom: 10px;
        }

        >p {
          font-size: 13px;
          margin-bottom: 5px;

          span.underline {
            color: #ae0c2a;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        >div {
          font-size: 13px;
          display: flex;

          p:last-child {
            flex: 1;
            cursor: pointer;
            color: #8f8f8f;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .otherInfo {
      margin-top: 15px;
      display: flex;
      justify-content: space-between;
      flex: 1;
      overflow: hidden;

      .order {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .orderFormInfo {
          display: flex;
        }

        .dateTimeList {
          background-color: #1a1a1ad1;
          padding-top: 15px;
          padding-bottom: 10px;
          cursor: pointer;
          flex: 1;

          .notime {
            height: 100%;
            text-align: center;
            line-height: 10;
            color: #515151;
          }

          .dateList {
            display: flex;
            box-sizing: border-box;
            padding-right: 2%;
            padding-left: 2%;
            max-height: 15.7vh;

            .left {
              width: 30px;
              height: 30px;
              background-color: #3e3e3e;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .left:hover,
            .right:hover {
              background-color: #ae0c2a;
            }

            .right {
              width: 30px;
              height: 30px;
              background-color: #3e3e3e;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .dateContainer {
              flex: 1;
              overflow: hidden;
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              white-space: nowrap;
              box-sizing: border-box;
              overflow-y: scroll;

              ::-webkit-scrollbar {
                width: 0 !important;
                height: 0 !important;
              }

              .date-item {
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #3e3e3e;
                color: white;
                font-size: 13px;
                border: 1px solid #515151;
                padding-left: 30px;
                padding-right: 30px;
                padding-top: 10px;
                padding-bottom: 10px;
                margin-bottom: 10px;
                margin-right: 6px;
                margin-left: 6px;
                border-radius: 2px;
              }

              p:hover {
                border: 1px solid #ae0c2a;
              }

              p.chose {
                background-color: #ae0c2a;
                border: 1px solid #ae0c2a;
              }
            }
          }

          .empty {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;

            span {
              padding-top: 20px;
              padding-bottom: 20px;
              color: #a0a0a0;
            }
          }

          .timeList {
            padding-left: 2%;
            padding-right: 2%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: flex-start;
            border-top: 1px solid #383737;
            padding-top: 10px;

            .time-item {
              padding-left: 20px;
              padding-right: 20px;
              /* width: 20%; */
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: #3e3e3e;
              color: white;
              border: 1px solid #3e3e3e;
              font-size: 13px;
              margin-bottom: 5px;
              margin-top: 5px;
              margin-right: 2px;
              margin-left: 2px;
              border-radius: 2px;
              padding-top: 10px;
              padding-bottom: 10px;
            }

            .time-chose {
              background-color: #ae0c2a;
            }
          }
        }

        .peopleList {
          background-color: #1a1a1ad1;
          width: 45%;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          height: 30vh;

          >.title {
            display: flex;
            justify-content: space-between;
            height: 35px;
            border-bottom: 1px solid #373636;

            .guideChange {
              height: 60%;
              background-color: #ae0c2a;
              color: white;
              outline: none;
              border: none;
              padding-left: 8px;
              padding-right: 8px;
              border-radius: 5px;
              margin-left: 10px;
              font-size: 12px;
            }

            div:first-child {
              display: flex;
              align-items: center;
              padding-left: 2%;

              p:first-child {
                color: white;
                font-size: 14px;
              }

              p:last-child {
                background-color: red;
                width: 18px;
                height: 18px;
                border-radius: 2px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 10px;

                i {
                  font-size: 12px;
                  color: white;
                }
              }
            }

            div:last-child {
              display: flex;
              align-items: center;
              color: white;
              padding-right: 20px;

              p:first-child {
                font-size: 13px;
              }
            }
          }

          .content {
            width: 100%;
            margin: 0 auto;
            text-align: left;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            flex: 1;
            overflow: auto;
            color: white;

            .title {
              display: flex;
              height: 40px;
              align-items: center;
              width: 100%;
              background-color: #30302e;
              border-bottom: 1px solid #373636;
            }

            p:first-child {
              width: 20%;
            }

            p:nth-child(2) {
              width: 50%;
              padding-left: 4px;
              padding-right: 8px;
            }

            .items {
              flex: 1;
              overflow-y: scroll;

              .item {
                width: 100%;
                display: flex;
                height: 40px;
                align-items: center;
                color: white;

                p:last-child {
                  color: #ae0c2a;

                  i {
                    margin-right: 5px;
                  }
                }
              }

              div:nth-child(even) {
                background-color: #30302e;
              }
            }

            div:first-child {
              color: #969696;
            }
          }

          .orderGuide {
            display: flex;
            justify-content: space-between;
            height: 40px;
            font-size: 16px;
            color: white;
            padding-left: 3%;
            padding-right: 3%;
            border-top: 1px solid #484848;
            align-items: center;
            box-shadow: 2px 2px 10px #ccc;

            div {
              color: white !important;
            }
          }
        }
      }

      .time-ban {
        color: gray !important;
        cursor: not-allowed;
        background: #666 !important;
      }

      .time-ban:hover {
        border: 1px solid transparent !important;
      }

      .commentList1 {
        flex: 1;
        overflow: hidden;
        background-color: #1a1a1ad1;
        margin-top: 5px;
        display: flex;
        flex-direction: column;

        .customPage {
          text-align: center;
        }

        .title {
          padding-bottom: 5px;
          padding-left: 10px;
          display: flex;
          justify-content: space-between;
          padding-right: 10px;
          padding-top: 10px;
          border-bottom: 1px solid #373636;
          padding-bottom: 10px;

          p {
            font-size: 13px;
            color: white;

            i {
              margin-left: 5px;
            }
          }

          p:first-child::before {
            content: ".";
            background-color: #ae0c2a;
            color: #ae0c2a;
            width: 1px;
            margin-right: 7px;
          }
        }

        .content {
          overflow-y: scroll;
          flex: 1;

          .comment {
            margin: 0 auto;
            width: 95%;
            border-bottom: 1px solid #373636;
            padding-bottom: 15px;
            padding-top: 15px;

            .info {
              display: flex;
              font-size: 12px;
              color: white;

              span {
                width: 20px;
                height: 20px;
                margin-right: 10px;
              }

              p {
                margin-right: 15px;
              }
            }

            .descri {
              display: flex;
              font-size: 12px;
              margin-top: 10px;
              color: white;

              p:first-child {
                line-height: 1.8;
              }

              p:last-child {
                color: #959595;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                line-clamp: 3;
                -webkit-box-orient: vertical;
                line-height: 1.7;
                flex: 1;
              }
            }
          }
        }
      }
    }
  }

  .commentList {
    flex: 1;
    overflow: hidden;
    background-color: #1a1a1ad1;
    margin-left: 15px;
    display: flex;
    flex-direction: column;

    .customPage {
      text-align: center;
    }

    .title {
      padding-bottom: 5px;
      padding-left: 10px;
      display: flex;
      justify-content: space-between;
      padding-right: 10px;
      padding-top: 10px;
      border-bottom: 1px solid #373636;
      padding-bottom: 10px;

      p {
        font-size: 13px;
        color: white;

        i {
          margin-left: 5px;
        }
      }

      p:first-child::before {
        content: ".";
        background-color: #ae0c2a;
        color: #ae0c2a;
        width: 1px;
        margin-right: 7px;
      }
    }

    .contentVu {
      overflow-y: scroll;
      overflow-x: hidden;
      flex: 1;
      padding: 15px;

      p,
      span {
        color: white !important;
        background-color: #1a1a1ad1 im !important;
      }
    }
  }

  .submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 15px;
    margin-bottom: 15px;
    padding-right: 15px;

    button {
      height: 40px;
      width: 110px;
      background-color: black;
      border: 1px solid white;
      color: white;
      outline: none;
    }

    .order {
      background-color: #ae0c2a;
      border: 1px solid #ae0c2a;
      margin-left: 10px;
    }

    .gray-info {
      background: #666;
      border: #eee;
      color: #333;
    }

    .clsoe {
      background-color: #ccc;
      margin-left: 10px;
    }
  }

  .nodata {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100%;
    width: 100%;
    color: #515151;
    justify-content: center;

    input {
      display: none;
    }

    img {
      height: 14vh;
      margin: 0vh auto;
      margin-top: 3vh;
      margin-bottom: 1vh;
    }

    .operate {
      .upload {
        color: #ae0c2a;
        text-decoration: underline;
        cursor: pointer;
      }

      .downLoad {
        text-decoration: underline;
        cursor: pointer;
        margin-left: 2px;

        a {
          color: #969696 !important;
        }
      }
    }
  }

  .comment-time {
    display: flex;
    font-size: 12px;
    color: #aaa;
    margin-top: 3px;
    align-content: center;
    line-height: 12px;
    justify-content: flex-start;

    .commont-button {
      cursor: pointer;
      margin-left: 10px;
      font-weight: bold;
      color: white;
    }
  }

  .comment-list-wrap {
    cursor: pointer;
    font-size: 12px;
    color: white;
    margin-top: 5px;
  }

  .commont-children-item {
    margin-top: 10px;
    margin-left: 20px;
  }
}

.people-item-wrap {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #999;
  width: 90%;
  margin: 10px auto 0px;
  padding-bottom: 10px;

  .info-content-wrap {
    flex: 1;

    .word-wrap {
      color: #eee !important;
    }

    .user-name-wrap {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      color: white;

      .user-name {
        min-width: 100px;
      }

      .user-name,
      .unit-wrap {
        color: white !important;
      }
    }

    .username-wrap {
      margin-top: 5px;
    }

    .cardNum-wrap {
      margin-top: 5px;
    }
  }

  .delete-btn-wrap {
    min-width: 40px;
    width: 40px;
    margin-left: 20px;
    height: 100%;
    display: flex;
    color: #ae0c2a !important;
    align-items: center;
    justify-content: center;
  }
}
</style>
<style scoped>
.dateContainer::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}

.dateContainer::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.dateContainer::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.dateContainer::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.dateContainer::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.dateContainer::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.dateContainer::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.dateContainer::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.dateContainer {
  scrollbar-arrow-color: #f4ae21;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #333;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8;
  /**/
  /*滚动条的基本颜色*/
}

.items::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}

.items::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.items::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.items::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.items::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.items::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.items::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.items::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.items {
  scrollbar-arrow-color: #f4ae21;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #333;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8;
  /**/
  /*滚动条的基本颜色*/
}

.content::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}

.content::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.content::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.content::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.content::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.content::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.content::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.content::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.content {
  scrollbar-arrow-color: #f4ae21;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #333;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8;
  /**/
  /*滚动条的基本颜色*/
}

.content::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 0px;
}

.content::-webkit-scrollbar {
  /*滚动条整体部分，其中的属性有width,height,background,border等（就和一个块级元素一样）（位置1）*/
  width: 2px;
  height: 2px;
  background-color: #22222261;
}

.content::-webkit-scrollbar-button {
  /*滚动条两端的按钮，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置2）*/
  /*background: #74d334;*/
  display: none;
}

.content::-webkit-scrollbar-track {
  /*外层轨道，可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果（位置3）*/
  /*background: #ff66d5;*/
  display: none;
}

.content::-webkit-scrollbar-track-piece {
  /*内层轨道，滚动条中间部分（位置4）*/
  /*background: #ff66d5;*/
}

.content::-webkit-scrollbar-thumb {
  /*滚动条里面可以拖动的那部分（位置5）*/
  background: #ae0c2a;
  border-radius: 15px;
  width: 0.1px;
}

.content::-webkit-scrollbar-corner {
  /*边角（位置6）*/
  background: #82afff;
}

.content::-webkit-scrollbar-resizer {
  /*定义右下角拖动块的样式（位置7）*/
  background: #ff0bee;
}

.content {
  scrollbar-arrow-color: #f4ae21;
  /**/
  /*三角箭头的颜色*/
  scrollbar-face-color: #333;
  /**/
  /*立体滚动条的颜色*/
  scrollbar-3dlight-color: #666;
  /**/
  /*立体滚动条亮边的颜色*/
  scrollbar-highlight-color: #666;
  /**/
  /*滚动条空白部分的颜色*/
  scrollbar-shadow-color: #999;
  /**/
  /*立体滚动条阴影的颜色*/
  scrollbar-darkshadow-color: #666;
  /**/
  /*立体滚动条强阴影的颜色*/
  scrollbar-track-color: #666;
  /**/
  /*立体滚动条背景颜色*/
  scrollbar-base-color: #f8f8f8;
  /**/
  /*滚动条的基本颜色*/
}

.searchItem .el-input .el-input__inner {
  height: 35px;
}
</style>
<style>
.closeModal {
  width: 100% !important;
}

.closeModal .tip {
  width: 98%;
  margin: 0 auto;
  color: red;
  font-size: 13px;
  margin-bottom: 20px;
}

.el-dialog {
  background-image: url("~@/assets/images/registerbg.jpg");
  background-repeat: no-repeat;
  background-position: bottom;
  background-color: #f1eee7;
  width: 30%;
}

.el-dialog__header {
  border: 1px solid #dadada;
  padding-bottom: 22px;
}

.el-pagination {
  padding: 0;
}

.el-pagination .el-pager li {
  background-color: #1a1a1ad1 !important;
  color: white;
}

.el-pagination .el-pager li.active {
  color: #ae0c2a;
  cursor: default;
}

.el-pagination button {
  background-color: #1a1a1ad1 !important;
}
</style>
<style>
#contentVu * {
  color: white !important;
  background-color: #1a1a1a1f !important;
}

.tag-wrap {
  color: rgb(174, 12, 42);
  border: 1px solid rgb(174, 12, 42);
  padding: 1px 3px;
  border-radius: 5px;
}

.el-tag {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/single/activityDetial.vue